module.exports = __webpack_public_path__ + "static/media/responsive.ad28958f.svg";